export default __webpack_public_path__ + "static/media/health_check_table_Hk.b79de20e.webp";